import { render, staticRenderFns } from "./certificationContent.vue?vue&type=template&id=48909420&scoped=true&"
import script from "./certificationContent.vue?vue&type=script&lang=js&"
export * from "./certificationContent.vue?vue&type=script&lang=js&"
import style0 from "./certificationContent.vue?vue&type=style&index=0&id=48909420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48909420",
  null
  
)

export default component.exports